import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { canCurrentProfileManageContent } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

const PlacesMenu = ({ isAccountManager, ...other }: $TSFixMe) =>
    isAccountManager ? (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.PlacesPin} />}
            primaryText={<LocalizedText textKey={TextKey.PlacePlural} />}
            {...other}
        >
            {createListItemWithLink({
                textKey: TextKey.CityPlural,
                iconName: IconName.Property,
                path: 'City/Index',
            })}
        </SidebarExpandableListItem>
    ) : null;

export default connect(
    createStructuredSelector({
        isAccountManager: canCurrentProfileManageContent,
    })
)(PlacesMenu);
